export default defineNuxtPlugin((_nuxtApp) => {
  return {
    name: 'setup-stores',
    hooks: {
      'app:created': () => {
        // Import the stores
        const membersStore = useMembersStore()
        const subkrewesStore = useSubKrewesStore()

        // Setup cross-store subscriptions
        membersStore.setupSubscriptions()
        subkrewesStore.setupSubscriptions()
      },
    },
  }
})
